import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Alert, Box, Divider, Accordion, AccordionSummary, AccordionDetails, Typography } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { getRofBurnsBatchMedia } from '../../../../../../actions/rof-burns/rof-actions';

export default function RofBatchMedia({ projectKey }) {
    const dispatch = useDispatch()
    const rofMedia = useSelector(state => state.rofBurnsReducer.batchMedia)?.data
    const [hideState, setHideState] = useState({})

    useEffect(() => {
        dispatch(getRofBurnsBatchMedia(projectKey))
    }, [dispatch, projectKey])

    const toggleHide = (batchId) => {
        setHideState(prevState => ({
            ...prevState,
            [batchId]: !prevState[batchId]
        }))
    }

    const renderPhotos = (photos, title) => (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Typography variant='h6'>{title}</Typography>
            {!photos.length
                ? <Alert severity="info">No {title} media</Alert>
                : <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '16px' }}>
                    {photos.map((photo, index) => (
                        <img key={index} src={photo} alt={`${title} Photo ${index}`} width="300" />
                    ))}
                </Box>
            }
        </Box>
    )

    // New: render kiln-grouped photos
    const renderKilnPhotos = (kilnPhotosObj, title) => {
        if (!kilnPhotosObj || Object.keys(kilnPhotosObj).length === 0) {
            return <Alert severity="info">No {title} media</Alert>;
        }
        return (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Typography variant='h6'>{title}</Typography>
                {Object.entries(kilnPhotosObj).map(([kilnId, photos]) => (
                    <Box key={kilnId} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                            Kiln: {kilnId}
                        </Typography>
                        {photos.length === 0
                            ? <Alert severity="info">No media for this kiln</Alert>
                            : <Box
                                sx={{
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
                                    gap: '16px',
                                }}>
                                {photos.map((photo, idx) => (
                                    <img
                                        key={idx}
                                        src={photo}
                                        alt={`${title} Kiln ${kilnId} Photo ${idx}`}
                                        width="300" />
                                ))}
                            </Box>
                        }
                    </Box>
                ))}
            </Box>
        );
    };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            <Typography variant='h5'>Ring of Fire Batch Media</Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                {rofMedia && rofMedia.map((batch, index) => {
                    const hasNoRingOfFireMedia =
                        !batch.rofFeedstockPhotos.length &&
                        !batch.rofMoistureContentPhotos.length &&
                        !batch.rofBurnStartPhotos.length &&
                        (!batch.rofBulkDensityPhotos || Object.keys(batch.rofBulkDensityPhotos).length === 0) &&
                        (!batch.rofKilnDepthPhotos || Object.keys(batch.rofKilnDepthPhotos).length === 0) &&
                        (!batch.rofLogUnburntVolumePhotos || Object.keys(batch.rofLogUnburntVolumePhotos).length === 0);

                    return (
                        <Box key={index}>
                            {hasNoRingOfFireMedia && (
                                <Alert severity="info" sx={{ my: 3 }}>No Ring of Fire Media for Batch: {batch.batchId}</Alert>
                            )}
                            {!hasNoRingOfFireMedia && (
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                        onClick={() => toggleHide(`ROF - ${batch.batchId}`)}
                                    >
                                        <Typography>{hideState[`ROF - ${batch.batchId}`] ? "Hide" : "Expand"} {batch.batchId}</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography variant='h6'>Ring of Fire Media for Batch: {batch.batchId}</Typography>
                                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                            {renderPhotos(batch.rofFeedstockPhotos, 'Dry Feedstock')}
                                            {renderPhotos(batch.rofMoistureContentPhotos, 'Moisture Content')}
                                            {/* {renderPhotos(batch.rofBurnStartPhotos, 'Burn Start')} */}
                                            {renderKilnPhotos(batch.rofBulkDensityPhotos, 'Bulk Density')}
                                            {renderKilnPhotos(batch.rofKilnDepthPhotos, 'Kiln Depth')}
                                            {renderKilnPhotos(batch.rofLogUnburntVolumePhotos, 'Log Unburnt Volume')}
                                        </Box>
                                        <Divider />
                                    </AccordionDetails>
                                </Accordion>
                            )}
                        </Box>
                    )
                })}
            </Box>
            {/* <h2>Conservation Burns Batch Media</h2>
            {rofMedia && rofMedia.map((batch, index) => {
                const hasNoConservationBurnMedia =
                    !batch.cbMoistureContentPhotos.length &&
                    !batch.cbLogPileSizePhotos.length &&
                    !batch.cbLogFeedstockPileCountPhotos.length &&
                    !batch.cbBulkDensityPhotos.length &&
                    !batch.cbVolumeMeasurementPhotos.length &&
                    !batch.cbLogBiocharPileCountPhotos.length

                return (
                    <Box key={index}>
                        {hasNoConservationBurnMedia && (
                            <Alert severity="info" sx={{ my: 3 }}>No Conservation Burn Media for Batch: {batch.batchId}</Alert>
                        )}
                        {!hasNoConservationBurnMedia && (

                            <Accordion>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                    onClick={() => toggleHide(`CB - ${batch.batchId}`)}
                                >
                                    <Typography>{hideState[`CB - ${batch.batchId}`] ? "Hide" : "Expand"} {batch.batchId}</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <h3>Conservation Burn Media for Batch: {batch.batchId}</h3>
                                    {renderPhotos(batch.cbMoistureContentPhotos, 'Moisture Content')}
                                    {renderPhotos(batch.cbLogPileSizePhotos, 'Log Pile Size')}
                                    {renderPhotos(batch.cbLogFeedstockPileCountPhotos, 'Log Feedstock Pile Count')}
                                    {renderPhotos(batch.cbBulkDensityPhotos, 'Bulk Density')}
                                    {renderPhotos(batch.cbVolumeMeasurementPhotos, 'Volume Measurement')}
                                    {renderPhotos(batch.cbLogBiocharPileCountPhotos, 'Log Biochar Pile Count')}
                                </AccordionDetails>
                            </Accordion>
                        )}
                    </Box>
                )
            })} */}
        </Box>
    )
}